export const environment = {
  production: true,
  apiURL: 'https://api.tktah.dev/',
  imagesUrl: 'https://d1mgvtaa4vsyih.cloudfront.net',
}

export function getImageUrl(imagePath: string | null | undefined, fallback: string = ''): string {
  if (!imagePath) return fallback
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) return imagePath
  const baseUrl = environment.imagesUrl
  if (!baseUrl) return imagePath
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
  const cleanImagePath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`
  return `${cleanBaseUrl}${cleanImagePath}`
}
